import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import * as $ from 'jquery';
import { IRuteo } from './ruteo';
import { RuteosService } from './ruteos.service';
import { RuteosListComponent } from './ruteos-list.component';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import * as myGlobals from './../global';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { SucursalesService } from '../sucursales/sucursales.service';
import { ISucursal } from '../sucursales/sucursal';
import { IMerchant } from './merchant';
import { IIssuer } from './issuer';
import { IAccountingNature } from './accountingnature';
import { IServiceInstance } from './serviceinstance';
import { RouterModule, Routes } from '@angular/router';
import { HttpErrorValidator } from '../services/http-error-validator';
import { errorMessageFromAjax } from '../services/ajax-error';

@Component({
  selector: 'pm-ruteos',
  templateUrl: './ruteos.component.html',
  styleUrls: ['./ruteos.component.sass']
})
export class RuteosComponent implements OnInit, OnDestroy, AfterViewInit {
  public pageTitle = 'RUTEO';

  ruteosList: IRuteo[] = [];
  filteredRuteosList: IRuteo[];
  errorMessage = '';
  currentPg = 1;

  private _searchMerchant = '';
  private _searchIssuer = '';
  private _searchAccountingNature = '';
  private _searchServiceInstance = '';

  merchantList: Observable<IMerchant[]> = this.service.getMerchants();
  issuerList: Observable<IIssuer[]> = this.service.getIssuers();
  accountingNatureList: Observable<IAccountingNature[]> = this.service.getAccountingNatures();
  serviceInstanceList: Observable<IServiceInstance[]> = this.service.getServiceInstances();

  constructor(
    public service: RuteosService,
    private parent: RuteosListComponent,
    private router: Router,
    private spinnerService: NgxSpinnerService,
    private merchantService: SucursalesService,
    private httpErrorValidator: HttpErrorValidator
  ) {}

  ngAfterViewInit() {
    // $('#menu-ruteo').click();
    $('a[rel=ruteo]').addClass('selected');
  }

  get searchMerchant(): string {
    return this._searchMerchant;
  }

  set searchMerchant(value: string) {
    // console.log('searchMerchant: _searchMerchant: ', value);
    // console.log('searchMerchant: _searchIssuer: ', this._searchIssuer);
    // console.log('searchMerchant: _searchServiceInstance: ', this._searchServiceInstance);
    // console.log('searchMerchant: _searchAccountingNature: ', this._searchAccountingNature);
    this._searchMerchant = value;
    const filters = {
      merchantId: [this._searchMerchant],
      cardIssuerId: [this._searchIssuer],
      serviceInstanceId: [this._searchServiceInstance],
      accountingNature: [this._searchAccountingNature]
    };
    this.filteredRuteosList = this.filterRuteos();
  }

  get searchIssuer(): string {
    return this._searchIssuer;
  }

  set searchIssuer(value: string) {
    // console.log('searchIssuer: _searchMerchant: ', this._searchMerchant);
    // console.log('searchIssuer: _searchIssuer: ', value);
    // console.log('searchIssuer: _searchServiceInstance: ', this._searchServiceInstance);
    // console.log('searchIssuer: _searchAccountingNature: ', this._searchAccountingNature);
    this._searchIssuer = value;
    const filters = {
      merchantId: [this._searchMerchant],
      cardIssuerId: [this._searchIssuer],
      serviceInstanceId: [this._searchServiceInstance],
      accountingNature: [this._searchAccountingNature]
    };
    this.filteredRuteosList = this.filterRuteos();
  }

  get searchAccountingNature(): string {
    return this._searchAccountingNature;
  }

  set searchAccountingNature(value: string) {
    // console.log('searchAccountingNature: _searchMerchant: ', this._searchMerchant);
    // console.log('searchAccountingNature: _searchIssuer: ', this._searchIssuer);
    // console.log('searchAccountingNature: _searchServiceInstance: ', this._searchServiceInstance);
    // console.log('searchAccountingNature: _searchAccountingNature: ', value);
    this._searchAccountingNature = value;

    const filters = {
      merchantId: [this._searchMerchant],
      cardIssuerId: [this._searchIssuer],
      serviceInstanceId: [this._searchServiceInstance],
      accountingNature: [this._searchAccountingNature]
    };
    this.filteredRuteosList = this.filterRuteos();
  }

  get searchServiceInstance(): string {
    return this._searchServiceInstance;
  }

  set searchServiceInstance(value: string) {
    // console.log('searchServiceIstance: _searchMerchant: ', this._searchMerchant);
    // console.log('searchServiceIstance: _searchIssuer: ', this._searchIssuer);
    // console.log('searchServiceIstance: _searchServiceInstance: ', value);
    // console.log('searchServiceIstance: _searchAccountingNature: ', this._searchAccountingNature);
    this._searchServiceInstance = value;
    const filters = {
      merchantId: [this._searchMerchant],
      cardIssuerId: [this._searchIssuer],
      serviceInstanceId: [this._searchServiceInstance],
      accountingNature: [this._searchAccountingNature]
    };
    this.filteredRuteosList = this.filterRuteos();
  }

  filterRuteos() {
    console.log('filterRuteos: _searchMerchant: [', this._searchMerchant, ']');
    console.log('filterRuteos: _searchIssuer: [', this._searchIssuer, ']');
    console.log('filterRuteos: _searchServiceInstance: [', this._searchServiceInstance, ']');
    console.log('filterRuteos: _searchAccountingNature: [', this._searchAccountingNature, ']');

    return this.ruteosList.filter(
      ruteo =>
        (this._searchMerchant.trim() !== ' ' ? ruteo.merchantId.toString().indexOf(this._searchMerchant) !== -1 : '') &&
        (this._searchIssuer.trim() !== ' ' ? ruteo.cardIssuerId.toString().indexOf(this._searchIssuer) !== -1 : '') &&
        (this._searchServiceInstance.trim() !== ' '
          ? ruteo.serviceInstanceId.toString().indexOf(this._searchServiceInstance) !== -1
          : '') &&
        (this._searchAccountingNature.trim() !== ' '
          ? ruteo.accountingNature.toString().indexOf(this._searchAccountingNature) !== -1
          : '')
    );
  }

  newRuteo(): void {
    this.parent.showEditRuteo = false;
    this.parent.showRuteos = false;
    this.parent.showAddRuteo = true;
  }

  ngOnInit(): void {
    console.log('ngOnInit: Entrando...');
    this.spinner();
    this.queryRoutes();
  }

  queryRoutes(): void {
    this.service.getRuteos().subscribe(
      res => {
        console.log('ngOnInit: res: ', res);
        this.ruteosList = res;
        this.filteredRuteosList = this.ruteosList;
        console.log('ngOnInit: filteredRuteosList ready');
      },
      err => this.httpErrorValidator.validateError(err)
    );
  }

  borrar(elemento, index: number) {
    // console.log('RuteosComponent: borrar: index: ', index);
    // console.log('RuteosComponent: borrar: id: ', elemento.id);
    // console.log($(".edit")[num]);

    const self = this;
    $.ajax({
      url: myGlobals.baseApi + '/webadmin/v1/routing-rule/' + elemento.id,
      headers: {
        sessionToken: localStorage.getItem('sessionToken')
      },
      type: 'DELETE'
    }).done(function(response) {
      console.log('delete sucess!!');
      self.queryRoutes();
      // window.location.href = '/ruteo';
    }).fail(function(jqXHR) {
      alert('No se pudo eliminar la regla de ruteo: ' + errorMessageFromAjax(jqXHR));
    });
    console.log('reload');
  }

  edit(elemento, index: number) {
    console.log('Entrando: index: ', index);
    console.log('Entrando: id: ', elemento);
    this.parent.editnumber = elemento.id;
    this.parent.showRuteos = false;
    this.parent.showAddRuteo = false;
    this.parent.showEditRuteo = true;
  }

  public spinner(): void {
    this.spinnerService.show();
    setTimeout(() => {
      this.spinnerService.hide();
    }, 300);
  }

  public ngOnDestroy(): void {
    $('a[rel=ruteo]').removeClass('selected');
  }
}
